<script setup>
import { defineProps, defineEmits, ref } from "vue";
// import {onClickOutside} from '@vueuse/core'

 defineProps({
  isOpen: Boolean,
});

const emit = defineEmits(["modal-close"]);

const target = ref(null)
// onClickOutside(target, ()=>emit('modal-close'))

</script>

<template>
  <div v-if="isOpen" class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container" ref="target">
        <div class="modal-header">
          <slot name="header"> default header </slot>
        </div>
        <div class="modal-body">
          <slot name="content"> default content </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <div>
              <button @click.stop="emit('modal-close')">Close</button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y:scroll;
}
.modal-container {
    max-width: 600px;
    position:relative;
    margin: 100px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    border: 5px solid #d86c8e;
    border-radius: 9px;
    .modal-body{
        max-width:100%;
        width:auto;
        
    }
    .modal-footer{
        padding-top:20px;
        button{
            position: absolute;
            right: 0;
            top: 0;
            border-radius: 0 0 0 5px;
        }
    }
}

</style>